import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { IoAdd } from "react-icons/io5";
import { AiOutlineClear } from "react-icons/ai";
import { useStateValue } from "../Context/StateProvider";
import { getAllSongs } from "../Api";
import { actionType } from "../Context/reducer";
import SongCard from "./SongCard";

const DashboardSongs = () => {
  const [songFilter, setSongFilter] = useState("");
  const [isFocus, setisFocus] = useState(false);
  const [{ allSongs }, dispatch] = useStateValue();
  useEffect(() => {
    if (!allSongs) {
      getAllSongs().then((data) => {
        // console.log(data.songs);
        dispatch({
          type: actionType.SET_SONGS,
          allSongs: data.data,
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="w-full p-4 flex items-center justify-center flex-col">
      <div className="w-full flex justify-center items-center gap-20">
        <NavLink
          to={"/dashboard/Newsong"}
          className="flex items-center justify-center px-4 py-3 border rounded-md border-gray-300 hover:border-gray-500 hover:shadow-md cursor-pointer"
        >
          <IoAdd />
        </NavLink>

        <input
          className={`w-52 px-4 py-2 border ${
            isFocus ? "border-gray-500 shadow-md " : " border-gray-300"
          }
          rounded-md bg-transparent outline-none
          duration-150 transition-all ease-in-out text-base text-textColor font-semibold`}
          type="text"
          placeholder="Search more.."
          value={songFilter}
          onChange={(e) => setSongFilter(e.target.value)}
          onBlur={() => {
            setisFocus(false);
          }}
          onFocus={() => setisFocus(true)}
        />

        <i>
          <AiOutlineClear className="text-3xl text-textColor cursor-pointer" />
        </i>
      </div>

      {/* main container */}
      <div className="relative w-full my-4 p-4 border border-gray-300 rounded-md">
        {/* the count  */}
        <div className="absolute top-4 left-4 ">
          <p className="text-xl font-bold">
            <span className="text-sm font-semibold text-textColor">
              Count :{" "}
            </span>
            {allSongs?.length}
          </p>
        </div>
        <SongContainer data={allSongs} />
      </div>
    </div>
  );
};
export const SongContainer = ({ data }) => {
  // console.log(data);
  return (
    <div className="w-full flex flex-wrap gap-3 items-center justify-evenly">
      {data &&
        data.map((songs, i) => <SongCard key={songs._id} data={songs} />)}
    </div>
  );
};
export default DashboardSongs;
